<template>
    <div>
        <Navbar />
        <BuyNow />
        <PageTitle pageTitle="Blog Yazımız" />
        <SuccessStory pathUrl="https://dryyazilim.com.tr/anaokulu/assets/data/get.php"/>
        <Footer />
    </div>
</template>

<script>
import Navbar from '../Layouts/Navbar'
import PageTitle from '../Common/PageTitle'
import SuccessStory from '../SuccessStory/SuccessStory'
import Footer from '../Layouts/Footer'
import BuyNow from '../Layouts/BuyNow'

export default {
    name: 'SuccessStoryPage',
    components: {
    Navbar,
    PageTitle,
    SuccessStory,
    Footer,
    BuyNow
},
}
</script>